import { observer } from 'mobx-react';
import { Box, Button } from '@material-ui/core';
import { Flex } from '../Flex';
import TableColumnView from '../Table/TableColumnView';
import TableSearch from '../Table/TableSearch';
import { useStores } from '../../hooks/useStores';

const ProductTableHeader = ({
  columnDefs,
  handleColumnChange,
  handleSearchQuery,
}) => {
  const { allProductsPage } = useStores();
  return (
    <Flex justifyContent="space-between" width="100%">
      <Flex alignItems="center">
        {allProductsPage.areRowsSelected && (
          <Button
            data-testid="table-header-export-button"
            size="small"
            onClick={() => allProductsPage.openProductExportModal()}
            color="primary"
          >
            Export
          </Button>
        )}
        <Box ml={2}>
          {allProductsPage.areRowsSelected && (
            <Button
              data-testid="table-header-delete-button"
              color="secondary"
              size="small"
              onClick={() => allProductsPage.openProductDeleteModal()}
            >
              Delete
            </Button>
          )}
        </Box>
      </Flex>
      <Flex alignItems="center">
        {allProductsPage.isImporterJobInProgress && (
          <Button
            variant="text"
            size="small"
            onClick={allProductsPage.openProductImportProgressModal}
          >
            Import in progress
          </Button>
        )}
        <TableSearch handleSearchQuery={handleSearchQuery} />
        <TableColumnView
          columnDefs={columnDefs}
          handleColumnChange={handleColumnChange}
        />
      </Flex>
    </Flex>
  );
};

export default observer(ProductTableHeader);
